import { useGlobalState } from '@/hooks';
import type { IMenuItem } from '@/interfaces';
import { isAbsoluteUrl, isOpenInNewTab } from '@/utils';
import Link from 'next/link';
import { useRouter } from 'next/router';
import type React from 'react';
import { useMemo } from 'react';
import { AnnouncementLabel } from '../../Header.styles';
import { SingleMenuItemTitle } from './SingleMenuItem.styles';

const SingleMenuItem: React.FC<{ data: IMenuItem }> = ({ data }) => {
  const { asPath } = useRouter();
  const { pageUrl } = useGlobalState();

  // biome-ignore lint/correctness/useExhaustiveDependencies: asPath and data.url intentionally omitted — pageUrl change is the relevant signal
  const isActive = useMemo(() => {
    if (!data?.url) return false;
    if (isAbsoluteUrl(data.url)) return pageUrl === data.url;

    // Prefix match so /carrier?page=3 and /blog/<slug> still highlight their nav item
    const currentPath = asPath.split('?')[0].split('#')[0];
    if (data.url === '/') return currentPath === '/';

    return currentPath === data.url || currentPath.startsWith(`${data.url}/`);
  }, [pageUrl, asPath, data?.url]);

  const menuTitle = (
    <SingleMenuItemTitle isActive={isActive}>
      {data?.title}
      {data?.announcementLabel && <AnnouncementLabel>{data.announcementLabel}</AnnouncementLabel>}
    </SingleMenuItemTitle>
  );

  return !data?.url ? (
    menuTitle
  ) : (
    <Link href={data?.url ?? '#'} passHref target={isOpenInNewTab(data?.url)}>
      {menuTitle}
    </Link>
  );
};

export default SingleMenuItem;
